import type { JSX } from 'react';
import type { FieldErrors, UseFormRegisterReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ROLE_LABELS, type CompanyRoleName } from '../types/company-admin.types';

interface CompanyUserFormFieldsProps {
  firstNameProps: UseFormRegisterReturn;
  lastNameProps: UseFormRegisterReturn;
  phoneProps: UseFormRegisterReturn;
  errors: FieldErrors<{ firstName: string; lastName: string; phone?: string }>;
  selectedRole: CompanyRoleName;
  onRoleChange: (role: CompanyRoleName) => void;
}

export function CompanyUserFormFields({
  firstNameProps,
  lastNameProps,
  phoneProps,
  errors,
  selectedRole,
  onRoleChange,
}: CompanyUserFormFieldsProps): JSX.Element {
  return (
    <>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="firstName">First Name</Label>
          <Input id="firstName" {...firstNameProps} />
          {errors.firstName && (
            <p className="text-sm text-destructive">{String(errors.firstName.message)}</p>
          )}
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Last Name</Label>
          <Input id="lastName" {...lastNameProps} />
          {errors.lastName && (
            <p className="text-sm text-destructive">{String(errors.lastName.message)}</p>
          )}
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input id="phone" type="tel" {...phoneProps} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="role">Role</Label>
        <Select value={selectedRole} onValueChange={(v) => onRoleChange(v as CompanyRoleName)}>
          <SelectTrigger id="role">
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent>
            {(Object.keys(ROLE_LABELS) as CompanyRoleName[]).map((role) => (
              <SelectItem key={role} value={role}>
                {ROLE_LABELS[role]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}
